import { useEffect, useState } from 'react';
import { Container, Typography, Box, CircularProgress, Paper, Alert, AlertTitle, useMediaQuery } from '@mui/material';

import { getPatientFullName } from '../utils/DiactiveUtils';
import { getAuthUserId } from '../services/AuthService';
import { getPatientData } from '../services/PatientService';
import QuestionnairesTable from '../components/questionnaires/QuestionnairesTable';

const PatientDashboard = ({ role }) => {
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState(null);
  const [userData, setUserData] = useState(null);
  const [isPostEvalFilled, setIsPostEvalFilled] = useState(false);

  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'));

  useEffect(() => {
    const fetchPatient = async () => {
      try {
        const authUserId = getAuthUserId();
        const { userData, postEvalData } = await getPatientData(role, authUserId);
        setUserData(userData);
        setIsPostEvalFilled(Object.keys(postEvalData).length > 0);
      } catch (error) {
        setErrorMessage(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPatient();
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!userData) {
    return (
      <Container sx={{ pt: 4 }}>
        <Alert severity="error">
          <AlertTitle>Error</AlertTitle>
          {errorMessage}
        </Alert>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ pt: 3, pb: 3 }}>
      <Paper elevation={3} sx={{ padding: 4 }}>
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: 1,
          mb: 2
        }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column', ml: 1.2 }}>
            <Typography variant="h5" component="h1">
              {getPatientFullName(userData)}
            </Typography>
          </Box>
        </Box>
        <Box>
          <QuestionnairesTable
            patientId={userData.id}
            patientRole={userData.role}
            patientAge={userData.ageAtSignUp}
            authUserRole={role}
            isPostEvalActive={isPostEvalFilled}
            isMobile={isMobile}
          />
        </Box>
      </Paper>
    </Container>
  );
};

export default PatientDashboard;